// WU-2.3 — /api/directed-notes client. Paths WITHOUT the /api prefix
// (@/lib/api-client adds it). Shapes mirror the api routes exactly.
import { api } from "@/lib/api-client";
import type { DirectedNoteRecord } from "@capture/shared";

export type { DirectedNoteRecord };

export const directedNotesApi = {
  inbox: () => api.get<{ notes: DirectedNoteRecord[] }>("/directed-notes/inbox"),
  sent: (params?: { state?: string; all?: boolean }) => {
    const q = new URLSearchParams();
    if (params?.state) q.set("state", params.state);
    if (params?.all) q.set("all", "1");
    const qs = q.toString();
    return api.get<{ notes: DirectedNoteRecord[] }>(`/directed-notes/sent${qs ? `?${qs}` : ""}`);
  },
  recipients: () => api.get<{ users: { id: string; name: string | null }[] }>("/directed-notes/recipients"),
  create: (payload: { toUserId: string; body: string; documentId?: string }) =>
    api.post<{ note: DirectedNoteRecord }>("/directed-notes", payload),
  ack: (id: string, reply?: string) =>
    api.post<{ note: DirectedNoteRecord }>(`/directed-notes/${id}/ack`, reply ? { reply } : {}),
  retract: (id: string) => api.post<{ note: DirectedNoteRecord }>(`/directed-notes/${id}/retract`, {}),
};
